import HundredBricksAPIError from '../../HundredBricksAPIError';
class CURPError extends HundredBricksAPIError {
}
export default CURPError;
